module.exports = __webpack_public_path__ + "media/assets/icons/search-c47e2bcec49b9209f5ed38cf75decbc5.svg";